// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HttpError_wrapper__3ZoQk","code":"HttpError_code__1dnqK","title":"HttpError_title__BzkPf","link":"HttpError_link__2MbT4"};